const closeModal = (id) => {
  const modalElement = document.getElementById(id);

  if (modalElement) {
    // Remove Bootstrap classes and styles
    modalElement.classList.remove("show");
    modalElement.style.display = "none";

    // Remove 'modal-open' class from body
    document.body.classList.remove("modal-open");

    // Explicitly reset styles applied by Bootstrap
    document.body.style.overflow = ""; // Restore default scroll
    document.body.style.paddingRight = ""; // Reset padding added during modal open

    // Remove all existing backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((backdrop) => backdrop.remove()); // Use .remove() to ensure proper cleanup
  }
};
export default closeModal;